module.exports = __webpack_public_path__ + "static/media/MHRP25L0101.b4bc2cba.svg";